<script>
  import { createEventDispatcher, tick } from 'svelte';

  const dispatch = createEventDispatcher();

  /**
   * The text to copy to the clipboard.
   * @type {string}
   * @default ''
   */
  export let text;

  let textarea;

  const copy = async () => {
    textarea.select();
    document.execCommand('Copy');

    await tick();

    textarea.blur();
    dispatch('copy');
  };
</script>

<slot {copy} />
<textarea bind:this={textarea} value={text} />

<style>
  textarea {
    left: 0;
    bottom: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
    width: 1px;
    height: 1px;
    border: none;
    display: block;
    position: absolute;
  }
</style>
